import axios from "axios";
import { jwtDecode } from "jwt-decode";
import jwtEncode from "jwt-encode";
import { unoStore } from "./store";
import { myApplicationList, setCurrentApplicationId } from "./slice/applicationSlice";
import { saveConfig } from "./slice/configSlice";
import { saveUserData } from "./slice/userSlice";

const getConfiguration = async (applicationId, authTokenKey = "token") => {
  unoStore.dispatch(setCurrentApplicationId(applicationId));
  const UNO_URL = "https://api.simulanis.io";
  await axios
    .get(`${UNO_URL}/api/application/configuration/${applicationId}`)
    .then(async (response) => {
      const data = response.data.data.data;
      unoStore.dispatch(saveConfig({ data }));
      await getUserDetail(data, authTokenKey);
    })
    .catch((error) => {
      console.log(error.message);
    });
};

const fetchApplication = async (config, authToken) => {
  try {
    var { data } = await axios.get(`${config?.UNO_URL}/api/application/mine`, {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    });
    unoStore.dispatch(myApplicationList(data?.data));
  } catch (error) {
    console.log(error);
  }
};

const getUserDetail = async (config, authTokenKey) => {
  const urlParams = new URLSearchParams(window.location.search);
  const _tokenParam = urlParams.get("referrer");
  let token = "";
  var initialPath = null;
  if (_tokenParam) {
    const decoded = jwtDecode(_tokenParam);
    localStorage.setItem(authTokenKey, decoded.token);
    token = decoded.token;
    initialPath = decoded.redirectUri;
  } else if (localStorage.getItem(authTokenKey)) {
    token = localStorage.getItem(authTokenKey);
  }

  try {
    let response = await axios.get(`${config.UNO_URL}/api/user/me`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });

    if (response.status === 200) {
      localStorage.setItem(authTokenKey, response.data.data.token);
      const data = {
        token: response.data.data.token,
        user: response.data.data.user,
      };
      unoStore.dispatch(saveUserData(data));
      await fetchApplication(config, response.data.data.token);
    }
  } catch (error) {
    localStorage.clear();
    sessionStorage.clear();
    const payload = {
      origin: window.location.origin,
      redirectUri: window.location.pathname,
    };
    const token = jwtEncode(payload, "");
    return (window.location.href = `${config.redirectUri}?referrer=${token}`);
  }
};

export const initialize = async (applicationId, authTokenKey) => await getConfiguration(applicationId, authTokenKey);
